import { Youtube, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: 'Home', href: '/home' },
    { name: 'Features', href: '/features' },
    { name: 'Pricing', href: '/#pricing' },
    { name: 'About us', href: '/about-us' },
    { name: 'Contact', href: '/contact-us' },
  ];

  const socialLinks = [
    { icon: Youtube, href: '#', label: 'YouTube' },
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Top Section */}
        <div className="flex items-center justify-between mb-8">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex items-center space-x-2">
              <div className="relative">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 32V16L16 8L24 16V32H8Z"
                    fill="#6366F1"
                    opacity="0.6"
                  />
                  <path d="M16 32V16L24 8L32 16V32H16Z" fill="#4F46E5" />
                </svg>
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">SOBER</div>
                <div className="text-sm text-gray-600 -mt-1">HOUSE HUB</div>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-700 hover:text-indigo-600 transition-colors duration-200 text-base"
              >
                {link.name}
              </a>
            ))}
          </nav>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-6 border-t border-gray-200">
          {/* Copyright */}
          <p className="text-gray-600 text-sm mb-4 md:mb-0">
            Sober house hub @ {currentYear}. All rights reserved.
          </p>

          {/* Social Media Icons */}
          <div className="flex items-center space-x-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                aria-label={social.label}
                className="text-gray-700 hover:text-indigo-600 transition-colors duration-200"
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
